import { LoadingSpinner } from "@newsela/angelou";

import DataInfoCard from "@/components/DataInfoCard";
import {
  averageReadingLevelContentMainContainerCss,
  averageReadingLevelContentRowCss,
  averageReadingLevelContentRowValueCss,
  averageReadingLevelContentRowValueDescriptionCss,
  dataInfoCardCss,
} from "../../OverviewDataResults.style";

export interface AverageReadingLevelCardProps {
  averageGradeLevel: number | string;
  averageLexileLevel: string;
  isClassroomPage: boolean;
  studentFirstName?: string;
  loading: boolean;
  error?: boolean;
}
export interface AverageReadingLevelContentProps
  extends AverageReadingLevelCardProps {}
const AverageReadingLevelContent = ({
  averageGradeLevel,
  averageLexileLevel,
  loading,
  isClassroomPage,
  studentFirstName,
}: AverageReadingLevelContentProps) => {
  const firstRowValue = isClassroomPage
    ? "Average grade level for texts viewed by class"
    : `Average grade level for all texts viewed by ${studentFirstName}`;
  const secondRowValue = isClassroomPage
    ? "Average Lexile level for texts viewed by class"
    : `Average Lexile level for all texts viewed by ${studentFirstName}`;

  return (
    <div css={averageReadingLevelContentMainContainerCss}>
      <div css={averageReadingLevelContentRowCss}>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <strong css={averageReadingLevelContentRowValueCss}>
            {averageGradeLevel}
          </strong>
        )}
        <span css={averageReadingLevelContentRowValueDescriptionCss}>
          {firstRowValue}
        </span>
      </div>
      <div css={averageReadingLevelContentRowCss}>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <strong css={averageReadingLevelContentRowValueCss}>
            {averageLexileLevel}
          </strong>
        )}
        <span css={averageReadingLevelContentRowValueDescriptionCss}>
          {secondRowValue}
        </span>
      </div>
    </div>
  );
};
const AverageReadingLevelCard = ({
  averageGradeLevel,
  averageLexileLevel,
  isClassroomPage,
  studentFirstName,
  error,
  loading,
}: AverageReadingLevelCardProps) => {
  return (
    <DataInfoCard
      heading="Average reading level"
      tooltipDialog={{
        header: "Average reading level",
        body: isClassroomPage
          ? "Average reading level is based on the Lexile of all nonfiction texts viewed by students in this class"
          : "Reading level is based on the average level of nonfiction texts viewed by student",
      }}
      textContent={
        <AverageReadingLevelContent
          averageGradeLevel={averageGradeLevel}
          averageLexileLevel={averageLexileLevel}
          loading={loading}
          isClassroomPage={isClassroomPage}
          studentFirstName={studentFirstName ?? ""}
        />
      }
      additionalStyles={{ containerCss: dataInfoCardCss() }}
      error={!!error}
    />
  );
};

export default AverageReadingLevelCard;
